import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Box, Checkbox } from '@mui/material';
import { useSelector } from 'react-redux';
import { classes } from './utils';
import {
  ColumnSelection,
  ResponsiveSortingHeader,
  CustomLoadingOverlayComponent,
  CustomDropdownFilter,
} from './NestedComponents';
import { gridFilterSortStatus } from '../../../../services/allInvoiceApi';
import './AgGrid.css';
import { globalClasses } from '../../utils/globalUtils';
import Toast from '../../utils/Toast';

const AgGridTable = ({
  gridApi,
  setGridApi,
  columnApi,
  setColumnApi,
  setSelectedRows,
  setTotalData,
  setDataCount,
  className,
  columnData,
  enterPressed,
  functionData,
  getRowData,
  DocumentCompletedId,
  DocumentCompletedData,
  DocumentFailedReason,
  gridSettingData,
  searchValue,
  gridKey,
  allRowSelected,
  setAllRowSelected,
  customFilterValue,
  setCustomFilterValue,
  transactionData,
  mapData,
  updateOpenedData,
  selectedVersion,
  changedData,
  versionId,
  isEditing,
  setIsEdited,
  isEdited,
}) => {
  const [columnDefs] = useState(columnData);
  const userDetail = useSelector((state) => state.user.user);
  const uploadStatus = useSelector((state) => state.isUploaded.isUploaded);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const rowSelection = useRef();
  const PAGE_LIMIT = 25;
  rowSelection.current = allRowSelected;

  const defaultColDef = {
    flex: 1,
    resizable: true,
    suppressMovable: true,
  };

  const functionForDataSource = async (
    api,
    filterValue,
    params,
    searchValues,
    data,
  ) => {
    let response = null;
    const page = params.endRow ? params.endRow / PAGE_LIMIT : null;
    if (api) {
      // if (filterValue && Object.keys(filterValue).length > 0) {
      response = await getRowData(
        params?.sortModel,
        searchValues,
        params?.filterModel,
        filterValue,
        data,
        page,
      );

      // } else {
      //   console.log('@@@@@@@@@@@@@@@');
      //   response = await getRowData(
      //     params?.sortModel,
      //     searchValues,
      //     params?.filterModel,
      //     data,
      //     page,
      //   );
      // }
    }
    return response;
  };

  const dataSource = useMemo(
    () => ({
      rowCount: undefined,
      getRows: async (params) => {
        try {
          gridApi?.showLoadingOverlay();
          const response = await functionForDataSource(
            gridApi,
            customFilterValue,
            params,
            searchValue,
            functionData,
          );
          const data =
            gridKey === 'Transactions' ||
            gridKey === 'subscriber-detail' ||
            gridKey === 'invited-subscriber-detail' ||
            gridKey === 'organizations-payment-history' ||
            gridKey === 'users' ||
            gridKey === 'versions'
              ? response || []
              : response?.data?.rows || [];
          const total = response?.data?.count || 0;
          setTotalData(data);
          setDataCount(data.length);
          setTimeout(() => {
            if (
              gridKey === 'Transactions' ||
              gridKey === 'subscriber-detail' ||
              gridKey === 'invited-subscriber-detail' ||
              gridKey === 'organizations-payment-history' ||
              gridKey === 'users' ||
              gridKey === 'versions'
            ) {
              const rowsThisPage = data.slice(params.startRow, params.endRow);
              let lastRow = -1;
              if (data.length <= params.endRow) {
                lastRow = data.length;
              }
              params.successCallback(rowsThisPage, lastRow);
            } else {
              // const rowsThisPage = data.slice(params.startRow, params.endRow);
              // let lastRow = -1;
              // if (data.length <= params.endRow) {
              //   lastRow = data.length;
              // }
              params.successCallback(data, total);
            }

            if (rowSelection.current) {
              gridApi.forEachNode((node) => {
                node.setSelected(rowSelection.current);
              });
            }
            if (data.length === 0) {
              gridApi?.showNoRowsOverlay(); // Show "No Data Found" if data is empty
            } else {
              gridApi?.hideOverlay(); // Hide overlays when data is present
            }
          }, 500);
        } catch (error) {
          gridApi?.hideOverlay();
          gridApi?.showNoRowsOverlay();
          return error;
        }
      },
    }),
    [functionData, customFilterValue, enterPressed, uploadStatus, gridApi],
  );

  const onGridReady = (params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    // console.log("params?.columnApi?.columnModel?.columnDefs",params?.columnApi?.columnModel?.columnDefs)
    // const customFilterArray = params?.columnApi?.columnModel?.columnDefs
    //   .filter((c) => c.type === 'checkBox')
    //   .map((m) => m.field);
    //   console.log("customFilterArray==>",customFilterArray)
    // const dropdownFilter = customFilterArray.reduce((acc, key) => {
    //   acc[key] = [];
    //   return acc;
    // }, {});
    // console.log('dropdownFilter,customFilterValue', dropdownFilter, customFilterValue);
    // setCustomFilterValue(dropdownFilter);
  };

  function getRowId(params) {
    return params.data.id;
  }

  const CheckBoxHeaderComponent = (params) => {
    const { api } = params;
    const setSelectAllRows = (isAllRowsSelected) => {
      setAllRowSelected(isAllRowsSelected);
      api.forEachNode((node) => {
        node.setSelected(isAllRowsSelected);
      });
    };

    const handleChange = (event) => {
      const { checked } = event.currentTarget;
      setSelectAllRows(checked);
    };

    useEffect(() => {
      const updateHeaderCheckbox = () => {
        const allNodes = [];
        api.forEachNode((node) => allNodes.push(node));
        const allSelected = allNodes.every((node) => node.isSelected());
        const someSelected = allNodes.some((node) => node.isSelected());
        if (allSelected) {
          setAllRowSelected(true);
        } else if (!someSelected) {
          setAllRowSelected(false);
        } else {
          setAllRowSelected(null); // For partial selection state (indeterminate)
        }
      };

      api.addEventListener('selectionChanged', updateHeaderCheckbox);

      return () => {
        api.removeEventListener('selectionChanged', updateHeaderCheckbox);
      };
    }, [api]);

    return (
      <Checkbox
        className={globalClasses.gridCheckBox}
        checked={rowSelection.current}
        onChange={(e) => handleChange(e)}
      />
    );
  };

  const gridOptions = {
    // rowHeight: 50,
    rowSelection: 'multiple',
    rowModelType: 'infinite',
    rowMultiSelectWithClick: true,
    suppressRowClickSelection: true,
    getRowId,

    onSelectionChanged,
    components: {
      HeaderCheckbox: CheckBoxHeaderComponent,
      ResponsiveSortingHeader,
      CustomDropdownFilter,
    },
    isRowSelectable: (rowNode) =>
      rowNode.data && gridKey === 'versions' ? rowNode.rowIndex !== 0 : true,
    getRowClass: (params) =>
      params.data && params.rowIndex === 0 && gridKey === 'versions'
        ? 'latest-version'
        : '',
  };
  function onSelectionChanged() {
    const selectedNodes = gridOptions.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }

  const sortFilterChanged = async () => {
    const colState = columnApi.getColumnState();
    const sortedColumn = colState.find((col) => col.sort !== null);
    const filterModel = gridApi.getFilterModel();

    const fieldsToValidate = [
      'created_at',
      'validate_at',
      'validate_date',
      'logout_time',
      'login_time',
    ];
    let isValid = true;
    fieldsToValidate.forEach((field) => {
      const dateFilter = filterModel[field];

      if (dateFilter && dateFilter.type === 'inRange') {
        const { dateFrom, dateTo } = dateFilter;
        const fromDate = new Date(dateFrom);
        const toDate = new Date(dateTo);
        if (fromDate > toDate) {
          isValid = false;
        }
      }
    });

    if (!isValid) {
      Toast({
        message: 'From Date must be less than or equal to To Date',
        variant: 'warning',
      });
      gridApi.setFilterModel({});
      return;
    }

    if (sortedColumn) {
      await gridFilterSortStatus(
        gridKey,
        {
          column: sortedColumn.colId,
          sort: sortedColumn.sort,
        },
        filterModel,
        customFilterValue,
      );
    } else {
      await gridFilterSortStatus(
        gridKey,
        {
          column: null,
          sort: null,
        },
        filterModel,
        customFilterValue,
      );
    }
  };

  useEffect(() => {
    if (DocumentCompletedId && DocumentCompletedData) {
      if (gridApi) {
        const node = gridApi.getRowNode(DocumentCompletedId);

        if (node) {
          node.data.status = DocumentCompletedData;

          if (DocumentFailedReason) {
            node.data.reason = DocumentFailedReason;
          }

          node.updateData({ ...node.data });
        }
      }
    }
  }, [
    DocumentCompletedId,
    DocumentCompletedData,
    DocumentFailedReason,
    gridApi,
  ]);

  useEffect(() => {
    if (
      gridSettingData &&
      Object.keys(gridSettingData).length > 0 &&
      columnApi !== null
    ) {
      const colState = columnApi.getColumnState();
      const sortedColumn = colState.find(
        (col) => col.colId === gridSettingData?.sort?.column,
      );
      const filterModel = gridSettingData?.filter?.filterModel;

      if (sortedColumn) {
        // Set the sort state for the column
        columnApi.applyColumnState({
          state: [
            {
              colId: sortedColumn.colId,
              sort: gridSettingData?.sort?.sort,
            },
          ],
          applyOrder: true,
        });
      }

      // Apply filter model if it exists
      if (filterModel) {
        gridApi.setFilterModel(filterModel);
      }

      if (gridSettingData?.filter?.dropDownFilter) {
        setCustomFilterValue(gridSettingData.filter.dropDownFilter);
      }
    }
  }, [gridSettingData, columnApi]);

  return (
    <Box
      height="100%"
      // className={gridKey === 'Transactions' && classes.TransactionHeight}
    >
      <Box className={`ag-theme-alpine ${className}`}>
        <Box className={classes.ColumnSelectionBox}>
          <ColumnSelection
            columnDataForFilter={columnDefs}
            columnApi={columnApi}
            columnData={columnData}
            gridSettingData={gridSettingData}
            gridKey={gridKey}
            gridApi={gridApi}
            customFilterValue={customFilterValue}
          />
        </Box>
        <AgGridReact
          className="ag-root-wrapper"
          loadingOverlayComponent={CustomLoadingOverlayComponent}
          columnDefs={
            gridKey === 'Transactions'
              ? customFilterValue && Object.keys(customFilterValue).length > 0
                ? columnData(
                    gridSettingData,
                    gridKey,
                    customFilterValue,
                    transactionData,
                    mapData,
                    updateOpenedData,
                    selectedVersion,
                    changedData,
                    versionId,
                    isEditing,
                    setIsEdited,
                    isEdited,
                    screenWidth,
                  )
                : columnData(
                    gridSettingData,
                    gridKey,
                    null,
                    transactionData,
                    mapData,
                    updateOpenedData,
                    selectedVersion,
                    changedData,
                    versionId,
                    isEditing,
                    setIsEdited,
                    isEdited,
                    screenWidth,
                  )
              : customFilterValue && Object.keys(customFilterValue).length > 0
                ? columnData(
                    gridSettingData,
                    gridKey,
                    setCustomFilterValue,
                    customFilterValue,
                    userDetail,
                    screenWidth,
                  )
                : columnData(gridSettingData, gridKey, userDetail, screenWidth)
          }
          datasource={dataSource}
          defaultColDef={defaultColDef}
          onSortChanged={sortFilterChanged}
          onFilterChanged={sortFilterChanged}
          gridOptions={gridOptions}
          rowBuffer={0}
          cacheBlockSize={PAGE_LIMIT}
          cacheOverflowSize={PAGE_LIMIT}
          paginationPageSize={PAGE_LIMIT}
          maxConcurrentDatasourceRequests={1}
          onGridReady={onGridReady}
          overlayNoRowsTemplate="<span>No data found</span>"
        />
      </Box>
    </Box>
  );
};

AgGridTable.defaultProps = {
  functionData: undefined,
  DocumentCompletedId: undefined,
  DocumentCompletedData: undefined,
  DocumentFailedReason: undefined,
  gridSettingData: null,
  gridApi: null,
  columnApi: null,
};

AgGridTable.propTypes = {
  gridApi: PropTypes.shape({
    getSelectedNodes: PropTypes.func.isRequired,
    showLoadingOverlay: PropTypes.func.isRequired,
    hideOverlay: PropTypes.func.isRequired,
    showNoRowsOverlay: PropTypes.func.isRequired,
    forEachNode: PropTypes.func.isRequired,
    getRowNode: PropTypes.func.isRequired,
    getFilterModel: PropTypes.func.isRequired,
    setFilterModel: PropTypes.func.isRequired,
  }),
  setGridApi: PropTypes.func.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  setTotalData: PropTypes.func.isRequired,
  setDataCount: PropTypes.func.isRequired,
  getRowData: PropTypes.func.isRequired,
  functionData: PropTypes.string,
  columnData: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  DocumentCompletedId: PropTypes.string,
  DocumentCompletedData: PropTypes.string,
  DocumentFailedReason: PropTypes.string,
  enterPressed: PropTypes.bool.isRequired,
  gridSettingData: PropTypes.shape({
    id: PropTypes.string,
    user_id: PropTypes.string,
    grid_key: PropTypes.string,
    settings: PropTypes.shape({
      ' ': PropTypes.bool.isRequired,
      name: PropTypes.bool.isRequired,
      status: PropTypes.bool.isRequired,
      associatedTags: PropTypes.bool.isRequired,
      uploaded: PropTypes.bool.isRequired,
      versions: PropTypes.bool.isRequired,
    }),
    sort: PropTypes.shape({
      column: PropTypes.string,
      sort: PropTypes.string,
    }),
    filter: PropTypes.shape({
      filterModel: PropTypes.objectOf(
        PropTypes.shape({
          filterType: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          filter: PropTypes.string.isRequired,
        }),
      ),
      dropDownFilter: PropTypes.shape({
        status: PropTypes.arrayOf(
          PropTypes.shape({
            status: PropTypes.string.isRequired,
          }),
        ),
        associatedTags: PropTypes.arrayOf(
          PropTypes.shape({
            tag: PropTypes.string.isRequired,
          }),
        ),
      }).isRequired,
    }),
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  searchValue: PropTypes.string.isRequired,
  gridKey: PropTypes.string.isRequired,
  allRowSelected: PropTypes.bool.isRequired,
  setAllRowSelected: PropTypes.func.isRequired,
  customFilterValue: PropTypes.shape({}).isRequired,
  setCustomFilterValue: PropTypes.func.isRequired,
  setColumnApi: PropTypes.func.isRequired,
  columnApi: PropTypes.shape({
    getColumnState: PropTypes.func.isRequired,
    applyColumnState: PropTypes.func.isRequired,
  }),
  transactionData: PropTypes.arrayOf.isRequired,
  mapData: PropTypes.shape({}).isRequired,
  updateOpenedData: PropTypes.func.isRequired,
  selectedVersion: PropTypes.string.isRequired,
  changedData: PropTypes.shape({}).isRequired,
  versionId: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEdited: PropTypes.func.isRequired,
  isEdited: PropTypes.bool.isRequired,
  // selectedRows:
};

export default AgGridTable;
